// eslint-disable-next-line import/prefer-default-export
export const DATE_FIELDS = [
  'created_at',
  'created_by',
  'updated_at',
  'updated_by',
  'deleted_at',
  'deleted_by'
]
